module.exports = __webpack_public_path__ + "img/C2open.5d971850.gif";